import React from 'react';
import styled, { css } from 'styled-components';

import { MainForm } from 'helpers/form';
import { useImg, useText } from 'hooks';
import { MOBILE, DESKTOP, TO_DESKTOP, TABLET } from 'helpers/styles/media';

const FormBlock = () => {
  return (
    <>
      <Top>{useText('form__title', true)}</Top>
      <Body>
        <MainForm
          hideLabels
          inputCss={inputStyles}
          prefixCss={prefixStyles}
          phoneCss={phoneStyles}
          buttonCss={buttonStyles}
        />
        <Logo>
          {useImg('cta_visa.webp', 'visa')}
          {useImg('cta_mastercard.webp', 'mastercard')}
          {useImg('cta_skrill.webp', 'skrill')}
          {useImg('cta_neteller.webp', 'neteller')}
        </Logo>
        <Text>{useText('form__text', true)}</Text>
      </Body>
    </>
  );
};

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 50px;
  color: #4f4f4f;
  background-color: transparent;
  font-size: 18px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const Body = styled.div`
  background: #fff;

  @media ${TABLET} {
    background: transparent;
  }

  @media ${MOBILE} {
    background: transparent;
  }
`;

const inputStyles = css`
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 31px;

  @media ${MOBILE} {
    font-size: 13px;
  }

  input {
    padding: 15px;
  }
`;

const prefixStyles = css`
  flex: 0 0 105px;

  input {
    ${inputStyles}
  }
`;

const phoneStyles = css`
  input {
    ${inputStyles}
  }
`;

const buttonStyles = css`
  position: relative;
  border-color: transparent;
  text-align: center;
  min-height: 56px;
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  background: #8cc23c;
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 0 11px;
  color: #fff;
  transition: transform 0.3s ease;
  will-change: transform;

  @media ${DESKTOP} {
    &:hover {
      transform: scale(1.06);
    }
  }

  @media ${TO_DESKTOP} {
    &:active {
      transform: scale(1.06);
    }
  }

  @media ${MOBILE} {
    height: 51px;
    border-radius: 9px;
    font-size: 22px;
    line-height: 27px;
  }
`;

const Logo = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  margin-bottom: 10px;
`;

const Text = styled.div`
  font-size: 12px;
  line-height: 1.3;
  font-weight: 400;
  text-align: center;
  color: #6d6d6d;
`;

export default FormBlock;
